import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';

export default function isInkindPageRecipientInfoComplete(inkindPage: InkindPageAPIModel): boolean {
  return (
    inkindPage.recipientFullName && inkindPage.address && inkindPage.zip && inkindPage.city && !!inkindPage.stateCode
  );
}

export function isInkindPageRecipientInfoPartiallyComplete(inkindPage: Partial<InkindPageAPIModel>): boolean {
  return Boolean(
    inkindPage.recipientFullName || inkindPage.address || inkindPage.zip || inkindPage.city || !!inkindPage.stateCode
  );
}
